import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Ertigahirecorporateinpune() {



  const cardData =
  {
    keyword: ' Ertiga Hire for Corporate in Pune',
    heading: 'Pune Corporate Cars India Private Limited: Ertiga Hire for Corporate in Pune',
    headingDescription: 'Pune Corporate Cars India Private Limited offers dependable Ertiga hire for corporate in Pune, providing comfortable and economical travel solutions for employees, managers, and business guests. The spacious interiors and smooth ride quality of the Ertiga make it an ideal choice for daily office commute, airport transfers, corporate meetings, and industrial visits. With trained chauffeurs, flexible rental packages, and well-maintained vehicles, we ensure punctual, safe, and hassle-free travel across the city. Pune Corporate Cars India Private Limited delivers a reliable and cost-effective corporate travel experience with our Ertiga rental services in Pune.',

    top: 'Top Places to Visit in Pune with Pune Corporate Car',

 "topPlaces": [
    {
      "title": "Hinjewadi Rajiv Gandhi Infotech Park",
      "description": "Hinjewadi Phase 1, 2 and 3 together form Pune’s largest corporate ecosystem, home to global IT companies, MNCs, tech parks, and business hubs. With campuses of Infosys, Wipro, Cognizant, TCS and more, it is Pune’s primary employment corridor. The area has wide roads, 24×7 transport demand, cafes, business hotels, and constant corporate mobility needs — making it one of the busiest routes served by Pune Corporate Cars."
    },
    {
      "title": "Magarpatta Cybercity",
      "description": "Magarpatta Cybercity is a self-sustained corporate township combining IT parks, residential spaces, restaurants, and premium office buildings. Known for its clean, green, and secure environment, it hosts major IT giants like Accenture, Infosys, Capgemini and Barclays. Corporate travel requirements, employee drop services, and daily office commutes make it a major business hub in Pune."
    },
    {
      "title": "Kharadi EON IT Park",
      "description": "EON IT Park is Pune’s fastest-growing commercial destination, filled with high-rise IT towers, premium offices, and multinational companies. Its four major clusters (A, B, C, D) attract thousands of daily employees. With tech companies, co-working spaces, and international business centers, Kharadi is a top route for corporate pick-drop and airport transfers."
    },
    {
      "title": "Viman Nagar Business District",
      "description": "Viman Nagar is a premium corporate and lifestyle hub near Pune Airport, known for its modern business centers, coworking spaces, hotels, and commercial complexes. Major malls, restaurants, and connectivity to Kharadi, Koregaon Park, and Yerwada make it a preferred zone for corporate travel, meetings, and executive cab services."
    },
    {
      "title": "Baner–Balewadi Corporate Hub",
      "description": "Baner and Balewadi have transformed into Pune’s new-age commercial cluster with IT companies, startups, co-working hubs, and premium business towers. It offers a cosmopolitan corporate environment with cafés, boardrooms, and business hotels. The area’s proximity to Hinjewadi makes corporate cab requirements extremely high for daily office mobility."
    },
    {
      "title": "Chakan MIDC Industrial Area",
      "description": "Chakan MIDC is one of India’s biggest industrial and automobile manufacturing clusters, housing companies like Volkswagen, Mercedes-Benz, Bajaj, LG, and Mahindra. With 24×7 transport operations, staff shifts, and inter-plant travel, it is a prime location served by corporate cab services, staff shuttle operations, and industrial commute solutions."
    },
    {
      "title": "Talegaon MIDC",
      "description": "Talegaon MIDC is known for its global manufacturing units, auto plants, and logistics hubs. It hosts companies such as General Motors, L&T, JCB, and POSCO. The area witnesses heavy employee movement and frequent business visits from executives — making structured corporate mobility critical for smooth travel between Pune city and the MIDC."
    },
    {
      "title": "Yerwada Business Corridor",
      "description": "Yerwada is a major commercial zone with corporate towers, business parks, and high-end office spaces like ICC Tech Park and Commerzone. It is a preferred location for corporate meetings, finance companies, and consulting firms. Its close connectivity to the airport and EON makes it a frequent route for corporate cabs and executive travel."
    },
    {
      "title": "Koregaon Park Business & Lifestyle District",
      "description": "Koregaon Park blends premium business centers with high-end lifestyle spaces, cafés, and boutique offices. It attracts startups, creative agencies, international firms, and co-working workspaces. The area is ideal for board meetings, client visits, and VIP travel — heavily relying on professional chauffeur-driven cabs."
    },
    {
      "title": "Pimpri-Chinchwad Industrial Belt",
      "description": "PCMC is one of Pune’s strongest industrial belts, filled with auto, engineering, and manufacturing companies. Areas like Pimpri, Chinchwad, Bhosari, and Nigdi host major factories and R&D centers. With shift-based employee travel and factory visits, corporate cab services remain essential for day-to-day operations."
    }
  ],


"services": [
{
"name": "Ertiga Corporate Shuttle Pune",
"description": "Ertiga Corporate Shuttle Pune provides reliable multi-passenger Ertiga transport for corporate employees and office staff. The service focuses on safe, punctual, and comfortable commuting with structured routes, trained drivers, GPS tracking, and multi-shift support, making it ideal for IT parks, factories, and office campuses in Pune."
},
{
"name": "Ertiga Employee Transport Pune",
"description": "Ertiga Employee Transport Pune offers dedicated Ertiga vehicles for daily staff commuting. With consistent schedules, well-maintained vehicles, professional drivers, and GPS-enabled tracking, the service ensures timely pickups and drops while enhancing employee convenience and reducing corporate transportation management workload."
},
{
"name": "Company Ertiga Rental Pune",
"description": "Company Ertiga Rental Pune delivers long-term Ertiga rental solutions for organizations requiring employee transport, office commutes, and business travel. The service includes monthly plans, trained chauffeurs, optimized routes, and a fleet of well-maintained MPVs, ensuring reliable, safe, and cost-effective commuting for staff."
},
{
"name": "Ertiga Office Pickup Drop Pune",
"description": "Ertiga Office Pickup Drop Pune specializes in structured pickup and drop services for corporate employees using Ertiga vehicles. The service provides punctual, comfortable, and secure travel with professional drivers, optimized multi-shift routes, and GPS monitoring, ensuring efficient staff mobility across Pune."
},
{
"name": "Ertiga Business Travel Pune",
"description": "Ertiga Business Travel Pune offers professional Ertiga-based transportation for corporate trips, client visits, and inter-office travel. The service emphasizes comfort, safety, and punctuality, providing well-maintained vehicles, trained drivers, and flexible scheduling for business executives and staff."
},
{
"name": "Ertiga Outstation Hire Pune",
"description": "Ertiga Outstation Hire Pune provides reliable long-distance travel solutions for corporate employees, executives, and teams. The service includes GPS-tracked Ertiga vehicles with experienced drivers, comfortable seating, and optimized routes, ensuring safe and hassle-free outstation travel for business or personal purposes."
},
{
"name": "Ertiga Airport Transfer Pune",
"description": "Ertiga Airport Transfer Pune delivers safe and punctual transportation to and from Pune airport using spacious Ertiga MPVs. The service includes professional drivers, luggage assistance, and timely pickups, ensuring a comfortable and stress-free airport commute for corporate staff, executives, and VIP clients."
},
{
"name": "Best Ertiga Rental Pune",
"description": "Best Ertiga Rental Pune offers premium Ertiga vehicles for corporate and individual travel. The service focuses on reliable, safe, and comfortable transport with trained drivers, GPS-enabled tracking, and structured routes for office commutes, business trips, and VIP travel across Pune."
},
{
"name": "Affordable Ertiga Pune",
"description": "Affordable Ertiga Pune provides budget-friendly Ertiga rental services without compromising on quality or safety. Suitable for corporate staff, office employees, and group travel, the service ensures well-maintained vehicles, professional drivers, and timely pickups at competitive pricing."
},
{
"name": "Monthly Ertiga Hire Pune",
"description": "Monthly Ertiga Hire Pune offers long-term rental solutions for businesses requiring consistent staff transport. The service includes fixed monthly plans, structured daily schedules, trained chauffeurs, and GPS-monitored vehicles, ensuring safe, comfortable, and reliable commuting for large teams."
},
{
"name": "Ertiga Fleet Provider Pune",
"description": "Ertiga Fleet Provider Pune delivers a fully managed fleet of Ertiga MPVs for corporate and employee transportation. The service includes driver management, maintenance, GPS tracking, and optimized routing to provide businesses with seamless, safe, and efficient daily commuting solutions for staff."
},
{
"name": "Corporate MPV Hire Pune",
"description": "Corporate MPV Hire Pune specializes in providing multi-passenger Ertiga and similar MPVs for corporate transport needs. The service ensures structured commuting, trained drivers, GPS-enabled tracking, and comfort, making it ideal for office staff, IT employees, and corporate teams."
},
{
"name": "IT Employee Ertiga Cab",
"description": "IT Employee Ertiga Cab offers dedicated Ertiga transport solutions for IT park staff and tech company employees. The service features punctual pickups, safe travel, trained drivers, and GPS tracking to ensure smooth and reliable daily commutes for IT professionals across Pune."
},
{
"name": "Staff Transport Ertiga Pune",
"description": "Staff Transport Ertiga Pune delivers efficient multi-passenger transport for office and industrial employees using Ertiga MPVs. The service ensures timely pickups, structured routes, professional drivers, and safe commuting, making it an ideal choice for corporate staff mobility."
},
{
"name": "Ertiga Chauffeur Car",
"description": "Ertiga Chauffeur Car Pune provides professionally driven Ertiga vehicles for corporate executives, VIP clients, and staff transport. The service emphasizes comfort, safety, and punctuality, offering a reliable and premium commuting solution for office, business, and outstation travel."
}
],

"tableData": [
["Ertiga Corporate Shuttle Pune", "Ertiga Employee Transport Pune"],
["Company Ertiga Rental Pune", "Ertiga Office Pickup Drop Pune"],
["Ertiga Business Travel Pune", "Ertiga Outstation Hire Pune"],
["Ertiga Airport Transfer Pune", "Best Ertiga Rental Pune"],
["Affordable Ertiga Pune", "Monthly Ertiga Hire Pune"],
["Ertiga Fleet Provider Pune", "Corporate MPV Hire Pune"],
["IT Employee Ertiga Cab", "Staff Transport Ertiga Pune"],
["Ertiga Chauffeur Car", ""]
],


  






"whychoose": [
  {
    "WhyChooseheading": "Ertiga Hire for Corporate in Pune",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited offers premium Ertiga rental services for corporate clients in Pune, providing comfortable and reliable transportation for business travel."
  },
  {
    "WhyChooseheading": "Spacious & Comfortable Ertiga Fleet",
    "WhyChoosedescription": "Our Ertiga vehicles offer ample seating, superior comfort, and modern amenities, making them ideal for corporate employee travel and executive commuting."
  },
  {
    "WhyChooseheading": "Perfect for Team Travel & Corporate Events",
    "WhyChoosedescription": "Whether it’s employee pickups, business meetings, or corporate events, our Ertiga fleet ensures smooth and convenient transportation."
  },
  {
    "WhyChooseheading": "Professional Chauffeur Service",
    "WhyChoosedescription": "All rentals come with trained and courteous drivers, ensuring safe, disciplined, and timely travel for corporate clients."
  },
  {
    "WhyChooseheading": "Punctual & Hassle-Free Service",
    "WhyChoosedescription": "We ensure timely pickups and drops, minimizing delays and making corporate travel efficient and stress-free."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages",
    "WhyChoosedescription": "We provide hourly, daily, and long-term rental options, allowing businesses to choose plans that best suit their needs."
  },
  {
    "WhyChooseheading": "Safe & Sanitized Vehicles",
    "WhyChoosedescription": "All Ertiga vehicles are regularly sanitized, serviced, and equipped with modern safety features for secure corporate travel."
  },
  {
    "WhyChooseheading": "Efficient Booking & Coordination",
    "WhyChoosedescription": "Corporate travel can be managed effortlessly through our smooth booking process and reliable coordination."
  }
]






























  }

const faqData = [
  {
    question: 'Do you provide Ertiga hire services for corporate clients in Pune?',
    answer: 'Yes, Pune Corporate Cars India Private Limited offers Ertiga rentals for corporate travel, team outings, and executive transfers in Pune.',
  },
  {
    question: 'Why is Ertiga suitable for corporate travel?',
    answer: 'Ertiga provides spacious seating, comfortable legroom, and smooth rides, making it ideal for employee and executive transportation.',
  },
  {
    question: 'How can companies book Ertiga hire for corporate use?',
    answer: 'Bookings can be made through our website, mobile app, or by contacting our 24×7 corporate support team.',
  },
  {
    question: 'Can multiple Ertiga vehicles be booked for large corporate groups?',
    answer: 'Yes, Pune Corporate Cars India Private Limited provides fleet support for bulk bookings to accommodate large teams.',
  },
  {
    question: 'Are professional chauffeurs provided with Ertiga hire?',
    answer: 'Absolutely. All Ertiga bookings come with trained and professional chauffeurs to ensure a safe and comfortable ride.',
  },
  {
    question: 'Do you offer hourly and full-day rental packages for Ertiga?',
    answer: 'Yes, we provide flexible hourly, half-day, full-day, and event-based rental packages for corporate clients.',
  },
  {
    question: 'Can Ertiga be hired for VIP corporate guests?',
    answer: 'Yes, Ertiga is a comfortable and reliable choice for VIP executives and corporate clients.',
  },
  {
    question: 'What safety measures are implemented for Ertiga corporate rentals?',
    answer: 'All vehicles are GPS-enabled, sanitized regularly, and driven by verified and experienced chauffeurs.',
  },
  {
    question: 'What payment options are available for Ertiga corporate hire?',
    answer: 'We accept UPI, credit/debit cards, bank transfers, digital wallets, and provide corporate invoicing.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Sachin Gaikwad',
    feedback: 'We hired Ertiga cars for our corporate outing. Comfortable, punctual, and highly professional service.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Prerna Joshi',
    feedback: 'Excellent Ertiga hire service for corporate travel. Pune Corporate Cars India Private Limited ensured smooth and hassle-free transportation.',
    rating: 5,
  },
];

























































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];













const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Ertiga Hire for Corporate in Pune",
  "image": "https://www.punecorporatecars.com/assets/images/ertiga-corporate-pune.jpg", // replace with actual image URL
  "description": "Pune Corporate Cars India Private Limited offers Ertiga hire services for corporate clients in Pune, including employee transport, office pickup and drop, business travel, outstation trips, and airport transfers. Ideal for IT employees, corporate fleets, and monthly commute needs with comfort and reliability.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",  // update if needed
    "ratingCount": "5400", // update if needed
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2000", // starting price, adjust if needed
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/ertiga-hire-corporate-pune"
  }
};



  return (
    <div>

<Helmet>
  <title>Ertiga Hire for Corporate in Pune | Employee & Business Shuttle | Pune Corporate Cars India Private Limited</title>

  <meta
    name="description"
    content="Pune Corporate Cars India Private Limited offers Ertiga hire services for corporate clients in Pune, including employee transport, office pickup and drop, business travel, outstation trips, and airport transfers. Ideal for IT employees, corporate fleets, and monthly commute needs with comfort and reliability."
  />

  <meta
    name="keywords"
    content="Ertiga Corporate Shuttle Pune, Ertiga Employee Transport Pune, Company Ertiga Rental Pune, Ertiga Office Pickup Drop Pune, Ertiga Business Travel Pune, Ertiga Outstation Hire Pune, Ertiga Airport Transfer Pune, Best Ertiga Rental Pune, Affordable Ertiga Pune, Monthly Ertiga Hire Pune, Ertiga Fleet Provider Pune, Corporate MPV Hire Pune, IT Employee Ertiga Cab, Staff Transport Ertiga Pune, Ertiga Chauffeur Car"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/38.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Ertigahirecorporateinpune;